import { CommonModule } from "@angular/common";
import { HttpClientModule } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { SharedModule } from "src/app/shared/shared.module";
import { RouterModule } from "@angular/router";
import { BrowserModule } from "@angular/platform-browser";
import { dataProtectionRouter } from "./data-protection.router";
import { KeycloakAngularModule, KeycloakService } from "keycloak-angular";
import { DataProtectionDashboardComponent } from "./auth-tools/data-protection-dashboard/data-protection-dashboard.component";
import { ReportsComponent } from "./reports/reports.component";
import { MatInputModule } from "@angular/material/input";
import { MatSelectModule } from "@angular/material/select";
import { NgChartsModule } from "ng2-charts";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import {MatStepperModule} from '@angular/material/stepper';
import { DataAssetMappingComponent } from './data-asset-mapping/data-asset-mapping.component';
import { ViewMappingComponent } from './data-asset-mapping/view-mapping/view-mapping.component';
import { DataAssetMappingCreateOrUpdateComponent } from './data-asset-mapping/data-asset-mapping-create-or-update/data-asset-mapping-create-or-update.component';
import { DataProtectionProgramComponent } from './data-protection-program/data-protection-program.component';
import { DataProtectionProgramProcessComponent } from './data-protection-program/data-protection-program-process/data-protection-program-process.component';
import { DataProtectionProgramCompletedViewComponent } from './data-protection-program/data-protection-program-completed-view/data-protection-program-completed-view.component';

@NgModule({
  imports: [
    BrowserModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    CommonModule,
    RouterModule,
    dataProtectionRouter,
    KeycloakAngularModule,
    MatInputModule,
    MatSelectModule,
    NgChartsModule,
    MatStepperModule,
    NgbModule
  ],
  declarations: [
    DataProtectionDashboardComponent,
    ReportsComponent,
    DataAssetMappingComponent,
    ViewMappingComponent,
    DataAssetMappingCreateOrUpdateComponent,
    DataProtectionProgramComponent,
    DataProtectionProgramProcessComponent,
    DataProtectionProgramCompletedViewComponent
  ],
})
export class DataProtectionModule {}
